/**
 * 
{{ 'showmore.css' | asset_url | stylesheet_tag }}
<script src="{{ 'showmore.js' | asset_url }}" defer="defer"></script>

<more-data class="description-container {{ section.settings.alignment }}" style="--data-max-height: 90px" data-max-height="90">
    <more-content class="collection-description">
        <more-element>
            DATA
        </more-element>
    </more-content>

    <more-container class="more-button">
        <more-button data-more-text="Show more" data-less-text="Show less" role="button" aria-label="Label"></more-button>
    </more-container>
</more-data>
*/

if (!customElements.get('more-button')) {
	customElements.define(
		'more-button',
		class ShowMore extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.toggleMore.bind(this));
				this.addEventListener('keypress', this.keyPress);
			}

			connectedCallback() {
				const moreDataContainer = this.closest('more-data');
				const moreElement = moreDataContainer?.querySelector('more-element');
				if (!moreElement) return;

				// Read once: the attribute is rendered by Liquid and never changes at
				// runtime. A customiser setting change re-renders the section, which
				// runs connectedCallback again on the new element.
				const maxHeight = parseInt(moreDataContainer.getAttribute('data-max-height'), 10);

				const measure = () => {
					// offsetHeight is 0 while the content is not rendered - an inactive
					// product tab is display:none - so a measurement of 0 tells us
					// nothing and must not clear the button.
					const dataHeight = moreElement.offsetHeight;
					if (!dataHeight) return;

					moreDataContainer.classList.toggle('has-more-data', dataHeight > maxHeight);
				};

				measure();

				// Re-measure when the content first becomes visible (tab switch) or
				// reflows (font/image load, resize).
				this.resizeObserver = new ResizeObserver(measure);
				this.resizeObserver.observe(moreElement);
			}

			disconnectedCallback() {
				this.resizeObserver?.disconnect();
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.toggleMore();
				}
			}

			toggleMore() {
				this.classList.toggle('active');
				this.closest('more-data').classList.toggle('active');
			}
		}
	);
}
